module.exports = __webpack_public_path__ + "static/img/xiantiaolitishi.844cbda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiantiaolitishi.png
// module id = R7Gr
// module chunks = 3